import { FunctionComponent } from 'react';
import { TrashIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'next-i18next';

interface Props {
  onClick: () => void;
}

const CleanBtn: FunctionComponent<Props> = ({ onClick }) => {
  const { t } = useTranslation('common');
  
  return (
    <button
      className={'p-2 text-xs absolute right-2 bottom-2 flex space-x-2 items-center'}
      onClick={onClick}
    >
      <TrashIcon className="h-4 w-4" />
      <span>{t('codeRunner.console.clean')}</span>
    </button>
  );
};

export default CleanBtn;
